module.exports = __webpack_public_path__ + "a0f2a1dba6ea0fa071ba0e632af6b042.svg";